// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","funeral-info":"funeral-info","funeral-home-title":"funeral-home-title","address2":"address2","address":"address","addressMargin":"addressMargin"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/FuneralInfo/css/FuneralInfo.styl
// module id = 1569
// module chunks = 0